import React, { useEffect, useState } from "react";
import { useFormikContext, ErrorMessage, Field, Form } from "formik";
import { AiFillPlusCircle, AiFillSave } from "react-icons/ai";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import Select from "react-select";
import { countries } from "../../../data/options";
import axios from "axios";
import swal from "sweetalert";
import './FormAdd.css'
const FormAdd = ({ initValues, loading }) => {
  const { errors, touched, dirty, isValid, setValues, values, setFieldValue } =
    useFormikContext();
  const apiUrl = process.env.REACT_APP_API_URL;
  const [agents, setAgents] = useState([]);
  const [editableForAgents, setEditableForAgents] = useState(false);

  // Handle file input changes
  const handleFileChange = (event) => {
    const { name, files } = event.target;
    if (files && files[0]) {
      const file = files[0];
      // Validate file size (1MB max)
      const maxSize = 1024 * 1024; // 1MB
      if (file.size > maxSize) {
        alert(`${file.name} is too large. Maximum file size is 1MB.`);
        event.target.value = ''; // Clear the input
        return;
      }
      // Validate file type
      const allowedTypes = ['image/jpeg', 'image/png', 'image/jpg', 'application/pdf'];
      if (!allowedTypes.includes(file.type)) {
        alert(`${file.name} is not a valid file type. Only PDF and images are allowed.`);
        event.target.value = ''; // Clear the input
        return;
      }
      setFieldValue(name, file);
    }
  };

  const editableAgentsFunc = () => {
    setEditableForAgents(!editableForAgents);
    
    // if (editableForAgents) {
    //   if (values.agentId.length > 0) {
    //     axios
    //       .post(
    //         `${apiUrl}/agent/addAgent`,
    //         {
    //           name: values.agentId,
    //         },
    //         {
    //           headers: {
    //             loginToken: localStorage.getItem("loginToken"),
    //           },
    //         }
    //       )
    //       .then((result) => {
    //         swal({
    //           icon: "success",
    //           title: "Agent has been added",
    //           buttons: false,
    //           timer: 2000,
    //         });
    //         setAgents([...agents, result.data]);
    //       })
    //       .catch((err) => {
    //         if (err.response) {
    //           console.log(err);
    //           swal({
    //             title: "Error",
    //             icon: "error",
    //             text: err.response?.data?.error,
    //           });
    //         } else {
    //           console.log(err);
    //         }
    //       });
    //   }
    // }
  };

  useEffect(() => {
    setValues(initValues);
  }, [initValues, setValues]);

  useEffect(() => {
    axios
      .get(`${apiUrl}/agent`, {
        headers: {
          loginToken: localStorage.getItem("loginToken"),
        },
      })
      .then((res) => {
        // console.log(res.data);
        setAgents(Array.isArray(res.data) ? res.data : []);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  return (
    <Form className="w-full bg-white rounded-xl px-4 md:px-10 py-6 flex flex-col items-center justify-center min-h-full">
      <div className="w-full max-w-7xl">
        {/* Personal Information Section */}
        <div className="bg-gray-50 rounded-lg p-6 mb-8 shadow-sm">
          <h3 className="text-xl font-semibold text-gray-800 mb-6 border-b pb-2">Personal Information</h3>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
            <div className="flex flex-col">
              <label htmlFor="firstName" className="text-sm font-medium text-gray-700 mb-2">
                First Name *
              </label>
              <Field
                type="text"
                name="firstName"
                className={`w-full px-4 py-3 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 transition-colors ${
                  touched.firstName && errors.firstName
                    ? "border-red-500 text-red-800"
                    : "border-gray-300"
                }`}
                placeholder="Enter First Name"
              />
              <ErrorMessage name="firstName" component="div" className="text-red-600 text-sm mt-1" />
            </div>

            <div className="flex flex-col">
              <label htmlFor="lastName" className="text-sm font-medium text-gray-700 mb-2">
                Last Name *
              </label>
              <Field
                type="text"
                name="lastName"
                className={`w-full px-4 py-3 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 transition-colors ${
                  touched.lastName && errors.lastName
                    ? "border-red-500 text-red-800"
                    : "border-gray-300"
                }`}
                placeholder="Enter Last Name"
              />
              <ErrorMessage name="lastName" component="div" className="text-red-600 text-sm mt-1" />
            </div>

            <div className="flex flex-col">
              <label htmlFor="email" className="text-sm font-medium text-gray-700 mb-2">
                Email Address
              </label>
              <Field
                type="email"
                name="email"
                className={`w-full px-4 py-3 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 transition-colors ${
                  touched.email && errors.email
                    ? "border-red-500 text-red-800"
                    : "border-gray-300"
                }`}
                placeholder="Enter Email (optional)"
              />
              <ErrorMessage name="email" component="div" className="text-red-600 text-sm mt-1" />
            </div>

            <div className="flex flex-col">
              <label htmlFor="mobile" className="text-sm font-medium text-gray-700 mb-2">
                Mobile *
              </label>
              <Field
                type="tel"
                name="mobile"
                className={`w-full px-4 py-3 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 transition-colors ${
                  touched.mobile && errors.mobile
                    ? "border-red-500 text-red-800"
                    : "border-gray-300"
                }`}
                placeholder="Enter Mobile Number"
              />
              <ErrorMessage name="mobile" component="div" className="text-red-600 text-sm mt-1" />
            </div>

            <div className="flex flex-col">
              <label htmlFor="DOB" className="text-sm font-medium text-gray-700 mb-2">
                Date of Birth *
              </label>
              <DatePicker
                name="DOB"
                dateFormat="dd/MM/yyyy"
                selected={values.DOB}
                onChange={(date) => setFieldValue("DOB", date)}
                className={`w-full px-4 py-3 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 transition-colors ${
                  touched.DOB && errors.DOB
                    ? "border-red-500 text-red-800"
                    : "border-gray-300"
                }`}
                placeholderText="Select Date of Birth"
              />
              <ErrorMessage name="DOB" component="div" className="text-red-600 text-sm mt-1" />
            </div>

            <div className="flex flex-col">
              <label htmlFor="nationality" className="text-sm font-medium text-gray-700 mb-2">
                Nationality *
              </label>
              <Select
                name="nationality"
                onChange={(option) => setFieldValue("nationality", option.label)}
                options={countries}
                classNamePrefix="select"
                className={`w-full ${
                  touched.nationality && errors.nationality
                    ? "border-red-500"
                    : ""
                }`}
                placeholder="Select Nationality"
                styles={{
                  control: (provided, state) => ({
                    ...provided,
                    borderColor: state.isFocused ? '#3b82f6' : '#d1d5db',
                    boxShadow: state.isFocused ? '0 0 0 1px #3b82f6' : 'none',
                    '&:hover': {
                      borderColor: '#3b82f6',
                    },
                  }),
                }}
              />
              <ErrorMessage name="nationality" component="div" className="text-red-600 text-sm mt-1" />
            </div>

            <div className="flex flex-col">
              <label htmlFor="status" className="text-sm font-medium text-gray-700 mb-2">
                Status *
              </label>
              <Select
                name="status"
                onChange={(option) => setFieldValue("status", option.value)}
                options={[
                  { value: "Active", label: "Active" },
                  { value: "Inactive", label: "Inactive" },
                ]}
                classNamePrefix="select"
                className={`w-full ${
                  touched.status && errors.status
                    ? "border-red-500"
                    : ""
                }`}
                placeholder="Select Status"
                styles={{
                  control: (provided, state) => ({
                    ...provided,
                    borderColor: state.isFocused ? '#3b82f6' : '#d1d5db',
                    boxShadow: state.isFocused ? '0 0 0 1px #3b82f6' : 'none',
                    '&:hover': {
                      borderColor: '#3b82f6',
                    },
                  }),
                }}
              />
              <ErrorMessage name="status" component="div" className="text-red-600 text-sm mt-1" />
            </div>

            {typeof agentId === "undefined" && (
              <div className="flex flex-col">
                <label htmlFor="agentId" className="text-sm font-medium text-gray-700 mb-2">
                  Select Agent
                </label>
                {editableForAgents ? (
                  <Field
                    name="agentId"
                    placeholder="Enter agent name"
                    className={`w-full px-4 py-3 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 transition-colors ${
                      touched.agentId && errors.agentId
                        ? "border-red-500 text-red-800"
                        : "border-gray-300"
                    }`}
                  />
                ) : (
                  <Select
                    name="agentId"
                    onChange={(option) => setFieldValue("agentId", option.value)}
                    options={Array.isArray(agents)
                      ? agents.map((item) => ({
                          value: item.id,
                          label: item.name,
                        }))
                      : []}
                    classNamePrefix="select"
                    className={`w-full ${
                      touched.agentId && errors.agentId
                        ? "border-red-500"
                        : ""
                    }`}
                    placeholder="Select Agent (optional)"
                    styles={{
                      control: (provided, state) => ({
                        ...provided,
                        borderColor: state.isFocused ? '#3b82f6' : '#d1d5db',
                        boxShadow: state.isFocused ? '0 0 0 1px #3b82f6' : 'none',
                        '&:hover': {
                          borderColor: '#3b82f6',
                        },
                      }),
                    }}
                  />
                )}
                <ErrorMessage name="agentId" component="div" className="text-red-600 text-sm mt-1" />
                <button
                  onClick={() => editableAgentsFunc()}
                  type="button"
                  className="mt-2 px-4 py-2 bg-green-600 hover:bg-green-700 text-white rounded-lg transition-colors flex items-center justify-center gap-2"
                >
                  <AiFillPlusCircle />
                  {editableForAgents ? "Save Agent" : "Add Agent"}
                </button>
              </div>
            )}
          </div>
        </div>

        {/* Emergency Contact Section */}
        <div className="bg-gray-50 rounded-lg p-6 mb-8 shadow-sm">
          <h3 className="text-xl font-semibold text-gray-800 mb-6 border-b pb-2">Emergency Contact</h3>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
            <div className="flex flex-col">
              <label htmlFor="emName" className="text-sm font-medium text-gray-700 mb-2">
                Emergency Contact Name *
              </label>
              <Field
                type="text"
                name="emName"
                className={`w-full px-4 py-3 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 transition-colors ${
                  touched.emName && errors.emName
                    ? "border-red-500 text-red-800"
                    : "border-gray-300"
                }`}
                placeholder="Enter Emergency Contact Name"
              />
              <ErrorMessage name="emName" component="div" className="text-red-600 text-sm mt-1" />
            </div>

            <div className="flex flex-col">
              <label htmlFor="emMobile" className="text-sm font-medium text-gray-700 mb-2">
                Emergency Contact Mobile *
              </label>
              <Field
                type="tel"
                name="emMobile"
                className={`w-full px-4 py-3 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 transition-colors ${
                  touched.emMobile && errors.emMobile
                    ? "border-red-500 text-red-800"
                    : "border-gray-300"
                }`}
                placeholder="Enter Emergency Contact Mobile"
              />
              <ErrorMessage name="emMobile" component="div" className="text-red-600 text-sm mt-1" />
            </div>

            <div className="flex flex-col">
              <label htmlFor="bloodGroup" className="text-sm font-medium text-gray-700 mb-2">
                Blood Group *
              </label>
              <Field
                name="bloodGroup"
                as="select"
                className={`w-full px-4 py-3 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 transition-colors ${
                  touched.bloodGroup && errors.bloodGroup
                    ? "border-red-500 text-red-800"
                    : "border-gray-300"
                }`}
              >
                <option value="">Select Blood Group</option>
                <option value="A+">A+</option>
                <option value="A-">A-</option>
                <option value="B+">B+</option>
                <option value="B-">B-</option>
                <option value="AB+">AB+</option>
                <option value="AB-">AB-</option>
                <option value="O+">O+</option>
                <option value="O-">O-</option>
              </Field>
              <ErrorMessage name="bloodGroup" component="div" className="text-red-600 text-sm mt-1" />
            </div>
          </div>
        </div>

        {/* Passport Information Section */}
        <div className="bg-gray-50 rounded-lg p-6 mb-8 shadow-sm">
          <h3 className="text-xl font-semibold text-gray-800 mb-6 border-b pb-2">Passport Information</h3>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
            <div className="flex flex-col">
              <label htmlFor="paNo" className="text-sm font-medium text-gray-700 mb-2">
                Passport Number *
              </label>
              <Field
                name="paNo"
                type="text"
                className={`w-full px-4 py-3 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 transition-colors ${
                  touched.paNo && errors.paNo
                    ? "border-red-500 text-red-800"
                    : "border-gray-300"
                }`}
                placeholder="Enter Passport Number"
                autoComplete="off"
              />
              <ErrorMessage name="paNo" component="div" className="text-red-600 text-sm mt-1" />
            </div>

            <div className="flex flex-col">
              <label htmlFor="paIssueDate" className="text-sm font-medium text-gray-700 mb-2">
                Passport Issue Date *
              </label>
              <DatePicker
                name="paIssueDate"
                selected={values.paIssueDate}
                onChange={(date) => setFieldValue("paIssueDate", date)}
                className={`w-full px-4 py-3 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 transition-colors ${
                  touched.paIssueDate && errors.paIssueDate
                    ? "border-red-500 text-red-800"
                    : "border-gray-300"
                }`}
                dateFormat="dd/MM/yyyy"
                placeholderText="Select Issue Date"
              />
              <ErrorMessage name="paIssueDate" component="div" className="text-red-600 text-sm mt-1" />
            </div>

            <div className="flex flex-col">
              <label htmlFor="paExpDate" className="text-sm font-medium text-gray-700 mb-2">
                Passport Expiry Date *
              </label>
              <DatePicker
                name="paExpDate"
                selected={values.paExpDate}
                onChange={(date) => setFieldValue("paExpDate", date)}
                className={`w-full px-4 py-3 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 transition-colors ${
                  touched.paExpDate && errors.paExpDate
                    ? "border-red-500 text-red-800"
                    : "border-gray-300"
                }`}
                dateFormat="dd/MM/yyyy"
                placeholderText="Select Expiry Date"
              />
              <ErrorMessage name="paExpDate" component="div" className="text-red-600 text-sm mt-1" />
            </div>
          </div>
        </div>

        {/* Visa Information Section */}
        <div className="bg-gray-50 rounded-lg p-6 mb-8 shadow-sm">
          <h3 className="text-xl font-semibold text-gray-800 mb-6 border-b pb-2">Visa Information</h3>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
            <div className="flex flex-col">
              <label htmlFor="viStatus" className="text-sm font-medium text-gray-700 mb-2">
                Visa Status *
              </label>
              <Field
                name="viStatus"
                as="select"
                className={`w-full px-4 py-3 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 transition-colors ${
                  touched.viStatus && errors.viStatus
                    ? "border-red-500 text-red-800"
                    : "border-gray-300"
                }`}
              >
                <option value="">Select Status</option>
                <option value="Submitted">Submitted</option>
                <option value="Approved">Approved</option>
                <option value="Rejected">Rejected</option>
                <option value="Processing">Processing</option>
              </Field>
              <ErrorMessage name="viStatus" component="div" className="text-red-600 text-sm mt-1" />
            </div>

            <div className="flex flex-col">
              <label htmlFor="viIssueDate" className="text-sm font-medium text-gray-700 mb-2">
                Visa Issue Date *
              </label>
              <DatePicker
                name="viIssueDate"
                selected={values.viIssueDate}
                onChange={(date) => setFieldValue("viIssueDate", date)}
                className={`w-full px-4 py-3 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 transition-colors ${
                  touched.viIssueDate && errors.viIssueDate
                    ? "border-red-500 text-red-800"
                    : "border-gray-300"
                }`}
                dateFormat="dd/MM/yyyy"
                placeholderText="Select Issue Date"
              />
              <ErrorMessage name="viIssueDate" component="div" className="text-red-600 text-sm mt-1" />
            </div>

            <div className="flex flex-col">
              <label htmlFor="viExpDate" className="text-sm font-medium text-gray-700 mb-2">
                Visa Expiry Date *
              </label>
              <DatePicker
                name="viExpDate"
                selected={values.viExpDate}
                onChange={(date) => setFieldValue("viExpDate", date)}
                className={`w-full px-4 py-3 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 transition-colors ${
                  touched.viExpDate && errors.viExpDate
                    ? "border-red-500 text-red-800"
                    : "border-gray-300"
                }`}
                dateFormat="dd/MM/yyyy"
                placeholderText="Select Expiry Date"
              />
              <ErrorMessage name="viExpDate" component="div" className="text-red-600 text-sm mt-1" />
            </div>
          </div>
        </div>

        {/* Medical Information Section */}
        <div className="bg-gray-50 rounded-lg p-6 mb-8 shadow-sm">
          <h3 className="text-xl font-semibold text-gray-800 mb-6 border-b pb-2">Medical Information</h3>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
            <div className="flex flex-col">
              <label htmlFor="mcRefNo" className="text-sm font-medium text-gray-700 mb-2">
                MC Ref No
              </label>
              <Field
                type="text"
                name="mcRefNo"
                className={`w-full px-4 py-3 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 transition-colors ${
                  touched.mcRefNo && errors.mcRefNo
                    ? "border-red-500 text-red-800"
                    : "border-gray-300"
                }`}
                placeholder="Enter MC Reference Number"
                autoComplete="off"
              />
              <ErrorMessage name="mcRefNo" component="div" className="text-red-600 text-sm mt-1" />
            </div>

            <div className="flex flex-col">
              <label htmlFor="mcApprovalDate" className="text-sm font-medium text-gray-700 mb-2">
                Approval Date
              </label>
              <DatePicker
                name="mcApprovalDate"
                selected={values.mcApprovalDate}
                onChange={(date) => setFieldValue("mcApprovalDate", date)}
                className={`w-full px-4 py-3 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 transition-colors ${
                  touched.mcApprovalDate && errors.mcApprovalDate
                    ? "border-red-500 text-red-800"
                    : "border-gray-300"
                }`}
                dateFormat="dd/MM/yyyy"
                placeholderText="Select Approval Date"
              />
              <ErrorMessage name="mcApprovalDate" component="div" className="text-red-600 text-sm mt-1" />
            </div>

            <div className="flex flex-col">
              <label htmlFor="mcValidUntil" className="text-sm font-medium text-gray-700 mb-2">
                Valid Until
              </label>
              <DatePicker
                name="mcValidUntil"
                selected={values.mcValidUntil}
                onChange={(date) => setFieldValue("mcValidUntil", date)}
                className={`w-full px-4 py-3 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 transition-colors ${
                  touched.mcValidUntil && errors.mcValidUntil
                    ? "border-red-500 text-red-800"
                    : "border-gray-300"
                }`}
                dateFormat="dd/MM/yyyy"
                placeholderText="Select Valid Until Date"
              />
              <ErrorMessage name="mcValidUntil" component="div" className="text-red-600 text-sm mt-1" />
            </div>

            <div className="flex flex-col">
              <label htmlFor="mcStatus" className="text-sm font-medium text-gray-700 mb-2">
                Status
              </label>
              <Field
                name="mcStatus"
                as="select"
                className={`w-full px-4 py-3 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 transition-colors ${
                  touched.mcStatus && errors.mcStatus
                    ? "border-red-500 text-red-800"
                    : "border-gray-300"
                }`}
              >
                <option value="">Select Status</option>
                <option value="Approved">Approved</option>
                <option value="Pending">Pending</option>
                <option value="Rejected">Rejected</option>
                <option value="N/A">N/A</option>
              </Field>
              <ErrorMessage name="mcStatus" component="div" className="text-red-600 text-sm mt-1" />
            </div>

            <div className="flex flex-col">
              <label htmlFor="mcWith" className="text-sm font-medium text-gray-700 mb-2">
                MC With
              </label>
              <Field
                name="mcWith"
                as="select"
                className={`w-full px-4 py-3 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 transition-colors ${
                  touched.mcWith && errors.mcWith
                    ? "border-red-500 text-red-800"
                    : "border-gray-300"
                }`}
              >
                <option value="">Select Option</option>
                <option value="By Company">By Company</option>
                <option value="Himself">Himself</option>
              </Field>
              <ErrorMessage name="mcWith" component="div" className="text-red-600 text-sm mt-1" />
            </div>
          </div>
        </div>

        {/* Upload Documents Section */}
        <div className="bg-gray-50 rounded-lg p-6 mb-8 shadow-sm">
          <h3 className="text-xl font-semibold text-gray-800 mb-6 border-b pb-2">Upload Documents</h3>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
            <div className="flex flex-col">
              <label htmlFor="passportDoc" className="text-sm font-medium text-gray-700 mb-2">
                Passport Document
              </label>
              <input
                type="file"
                id="passportDoc"
                name="passportDoc"
                accept="image/jpeg,image/png,application/pdf"
                onChange={handleFileChange}
                className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 transition-colors file:mr-4 file:py-2 file:px-4 file:rounded-l-lg file:border-0 file:text-sm file:font-semibold file:bg-blue-50 file:text-blue-700 hover:file:bg-blue-100"
              />
              <p className="text-xs text-gray-500 mt-1">Optional - PDF or Image (max 1MB)</p>
            </div>

            <div className="flex flex-col">
              <label htmlFor="visaDoc" className="text-sm font-medium text-gray-700 mb-2">
                Visa Document
              </label>
              <input
                type="file"
                id="visaDoc"
                name="visaDoc"
                accept="image/jpeg,image/png,application/pdf"
                onChange={handleFileChange}
                className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 transition-colors file:mr-4 file:py-2 file:px-4 file:rounded-l-lg file:border-0 file:text-sm file:font-semibold file:bg-blue-50 file:text-blue-700 hover:file:bg-blue-100"
              />
              <p className="text-xs text-gray-500 mt-1">Optional - PDF or Image (max 1MB)</p>
            </div>

            <div className="flex flex-col">
              <label htmlFor="nidDoc" className="text-sm font-medium text-gray-700 mb-2">
                NID Document
              </label>
              <input
                type="file"
                id="nidDoc"
                name="nidDoc"
                accept="image/jpeg,image/png,application/pdf"
                onChange={handleFileChange}
                className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 transition-colors file:mr-4 file:py-2 file:px-4 file:rounded-l-lg file:border-0 file:text-sm file:font-semibold file:bg-blue-50 file:text-blue-700 hover:file:bg-blue-100"
              />
              <p className="text-xs text-gray-500 mt-1">Optional - PDF or Image (max 1MB)</p>
            </div>

            <div className="flex flex-col">
              <label htmlFor="cidbDoc" className="text-sm font-medium text-gray-700 mb-2">
                CIDB Document
              </label>
              <input
                type="file"
                id="cidbDoc"
                name="cidbDoc"
                accept="image/jpeg,image/png,application/pdf"
                onChange={handleFileChange}
                className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 transition-colors file:mr-4 file:py-2 file:px-4 file:rounded-l-lg file:border-0 file:text-sm file:font-semibold file:bg-blue-50 file:text-blue-700 hover:file:bg-blue-100"
              />
              <p className="text-xs text-gray-500 mt-1">Optional - PDF or Image (max 1MB)</p>
            </div>

            <div className="flex flex-col">
              <label htmlFor="insuranceDoc" className="text-sm font-medium text-gray-700 mb-2">
                Insurance Document
              </label>
              <input
                type="file"
                id="insuranceDoc"
                name="insuranceDoc"
                accept="image/jpeg,image/png,application/pdf"
                onChange={handleFileChange}
                className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 transition-colors file:mr-4 file:py-2 file:px-4 file:rounded-l-lg file:border-0 file:text-sm file:font-semibold file:bg-blue-50 file:text-blue-700 hover:file:bg-blue-100"
              />
              <p className="text-xs text-gray-500 mt-1">Optional - PDF or Image (max 1MB)</p>
            </div>
          </div>
        </div>

        {/* Submit Button */}
        <div className="flex justify-end mt-8">
          <button
            type="submit"
            disabled={loading || !(dirty && isValid)}
            className={`flex items-center gap-3 px-8 py-3 rounded-lg font-semibold transition-all duration-200 ${
              loading || !(dirty && isValid)
                ? "bg-gray-300 text-gray-500 cursor-not-allowed"
                : "bg-blue-600 hover:bg-blue-700 text-white shadow-lg hover:shadow-xl"
            }`}
          >
            <AiFillSave className="text-lg" />
            {loading ? "Submitting..." : "Submit Employee"}
          </button>
        </div>
      </div>
    </Form>
  );
};

export default FormAdd;
